import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  errorText: {
    color: theme.ErrorMessageColor,
    fontSize: 12,
    marginLeft: 12,
  },
});
const FieldError = ({ error, classes }) => (
  <span className={classes.errorText}>{error}</span>
);

export default withStyles(styles)(FieldError);
